import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

// Types
import type { Props } from '@/components/ui/IconedText'

// Props
import useThemeClassName from '@/hooks/useThemeClassName'

// Computed

export default /*#__PURE__*/_defineComponent({
  __name: 'IconedText',
  props: {
    theme: {}
  },
  setup(__props: any) {

const props = __props

// Use
const themeClassName = computed(() => useThemeClassName('iconed-text', props.theme))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["iconed-text", [themeClassName.value]])
  }, [
    _renderSlot(_ctx.$slots, "icon"),
    _createElementVNode("span", null, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _renderSlot(_ctx.$slots, "iconAppend")
  ], 2))
}
}

})